exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2oSb-9-R2n8JbViUE89tg5:focus{outline:1px solid var(--neutralSecondary)!important}._2oTj4o33-OWWsIU63vEytS{cursor:pointer}", ""]);
// Exports
exports.locals = {
	"persona": "_2oSb-9-R2n8JbViUE89tg5",
	"personaName": "_2oTj4o33-OWWsIU63vEytS"
};